import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalWrapper from '../../../components/modalWrapper';
import Loading from '../../../components/common/Loading';

function ModalChargeConfirm({
    openModal,
    setOpenModal,
    invoiceData,
    actionType = 'charge',
    onConfirm,
    onComplete,
}) {
    const { t } = useTranslation();
    const [step, setStep] = useState('confirm'); // 'confirm' | 'loading' | 'result'
    const [result, setResult] = useState(null);
    const [errors, setErrors] = useState(null);
    const [copied, setCopied] = useState(false);

    function handleClose() {
        const wasSuccess = step === 'result' && result && !errors;
        setOpenModal(false);
        setStep('confirm');
        setResult(null);
        setErrors(null);
        setCopied(false);
        if (wasSuccess && onComplete) {
            onComplete();
        }
    }

    async function handleConfirm() {
        if (!onConfirm || !invoiceData) return;
        setStep('loading');
        setResult(null);
        setErrors(null);

        const autoAdvance = actionType === 'charge';

        try {
            const response = await onConfirm(invoiceData, autoAdvance);
            setResult(response);
            setStep('result');
        } catch (err) {
            setErrors(err?.errors || [t('chargeFailed')]);
            setStep('result');
        }
    }

    const title = actionType === 'charge' ? t('chargeConfirmTitle') : t('sendInvoiceConfirmTitle');

    const renderConfirm = () => (
        <>
            <div className="modal_container__body__text">
                {actionType === 'charge'
                    ? t('chargeConfirmText', {
                        invoiceNo: invoiceData?.invoice_number,
                        amount: invoiceData?.payment_amount,
                    })
                    : t('sendInvoiceConfirmText', {
                        invoiceNo: invoiceData?.invoice_number,
                        amount: invoiceData?.payment_amount,
                    })
                }
            </div>
            <div
                style={{
                    display: 'flex',
                    gap: '12px',
                    justifyContent: 'center',
                    marginTop: '16px',
                }}
            >
                <div
                    className="button_red_small"
                    style={{ width: 'unset' }}
                    onClick={handleConfirm}
                >
                    {t('confirm')}
                </div>
                <div
                    className="button_red_small"
                    style={{ width: 'unset', opacity: 0.7 }}
                    onClick={handleClose}
                >
                    {t('cancel')}
                </div>
            </div>
        </>
    );

    const renderLoading = () => (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '30px 0' }}>
            <Loading noText fast scroll={false} />
        </div>
    );

    const renderResult = () => {
        if (errors) {
            return (
                <>
                    <div className="modal_container__body__text" style={{ color: '#d32f2f' }}>
                        {errors.map((msg, i) => (
                            <div key={i}>{msg}</div>
                        ))}
                    </div>
                    <div
                        className="button_red_small"
                        style={{ width: 'unset', marginTop: '16px' }}
                        onClick={handleClose}
                    >
                        {t('close')}
                    </div>
                </>
            );
        }

        return (
            <>
                <div className="modal_container__body__text">
                    <div><strong>{t('chargeResult')}</strong></div>
                    {result?.message && (
                        <div style={{ marginTop: '8px' }}>
                            {result.message}
                        </div>
                    )}
                    <div style={{ marginTop: '8px' }}>
                        Invoice ID: {result?.invoiceId}
                    </div>
                    {result?.invoiceLink && (
                        <div
                            style={{ marginTop: '8px', cursor: 'pointer', color: '#fe4b4e', textDecoration: 'underline' }}
                            onClick={() => {
                                navigator.clipboard.writeText(result.invoiceLink);
                                setCopied(true);
                                setTimeout(() => setCopied(false), 2000);
                            }}
                        >
                            {copied ? t('copiedToClipboard') : t('viewChargeInvoice')}
                        </div>
                    )}
                </div>
                <div
                    className="button_red_small"
                    style={{ width: 'unset', marginTop: '16px' }}
                    onClick={handleClose}
                >
                    {t('close')}
                </div>
            </>
        );
    };

    return (
        <ModalWrapper
            headerTitle={title}
            openModal={openModal}
            setModalWrapper={handleClose}
        >
            {step === 'confirm' && renderConfirm()}
            {step === 'loading' && renderLoading()}
            {step === 'result' && renderResult()}
        </ModalWrapper>
    );
}

export default ModalChargeConfirm;
